import '../financeiro-documento.css';
import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import { DefaultContainer } from '../../../../components/template/Main';
import { GetTipoData, GetEntidadeData } from './util';
import { LoadAll } from '../utils/Documento';
import DataGrid, {
    Scrolling,
    LoadPanel,
    Toolbar,
    Column,
    Lookup,
    Format,
    GroupPanel,
    Grouping,
    Item,
    Paging,
    SearchPanel,
    Sorting,
} from 'devextreme-react/data-grid';

import './DocumentoList.css';

export const DocumentoList = () => {
    document.title = 'MyMoney - Documento (lista)';

    const [entidadeData, setEntidadeData] = useState([]);
    const [tipoData, setTipoData] = useState([]);
    const [documentos, setDocumentos] = useState([]);
    const [recorrenteFilter, setRecorrenteFilter] = useState(true);
    const [abertoFilter, setAbertoFilter] = useState(true);
    const [todosFilter, setTodosFilter] = useState(false);
    const [agruparPorTipo, setAgruparPorTipo] = useState(true);
    const navigate = useNavigate();

    const LoadData = useCallback(async () => {
        try {
            const [tipos, entidades, documentosData] = await Promise.all([
                GetTipoData(),
                GetEntidadeData(),
                LoadAll(),
            ]);

            setTipoData(tipos);
            setEntidadeData(entidades);
            setDocumentos(documentosData || []);
        } catch (error) {
            console.error("Erro ao carregar dados:", error);
        }
    }, []);

    useEffect(() => {
        LoadData();
    }, [LoadData]);

    // Função para lidar com o clique no botão "Todos"
    const handleTodosClick = () => {
        setTodosFilter(true);
        setRecorrenteFilter(false);
        setAbertoFilter(false);
        setAgruparPorTipo(false)
    };

    // Função para alternar os filtros individuais e desativar "Todos"
    const handleFilterChange = (filterSetter) => {
        setTodosFilter(false);
        filterSetter(prev => !prev);
    };

    // Aplicação dos filtros nos documentos
    const filteredDocuments = documentos.filter(doc => {
        if (todosFilter) return true;
        if (recorrenteFilter && abertoFilter) {
            return doc.recorrente === 1 || doc.manter_aberto === 1;
        }
        if (recorrenteFilter) return doc.recorrente === 1;
        if (abertoFilter) return doc.manter_aberto === 1;
        return true;
    });

    const cellRenderId = (cell) => (
        <a href={`/financeiro/documentos/${cell.data.uuid}`} target="_blank" rel="noopener noreferrer">
            {cell.data.id}
        </a>
    );

    return (
        <DefaultContainer title="Lista de Documentos">
            <DataGrid
                dataSource={filteredDocuments}
                allowColumnResizing
                allowColumnReordering
                rowAlternationEnabled
                showColumnLines
                showBorders
                showRowLines
                height="100%"
                sorting={{ mode: "single" }}
                onRowDblClick={(e) => navigate(`/financeiro/documentos/${e.data.uuid}`)}
                grouping={{ autoExpandAll: agruparPorTipo }}
            >
                <Toolbar>
                    <Item location="before">
                        <i className="mx-2 fas fa-sync-alt" onClick={LoadData} />
                        <i className="mx-2 fa-solid fa-plus" onClick={() => navigate('/financeiro/documentos/create')} />
                    </Item>

                    {/* Filtros ao lado do campo de pesquisa */}
                    <Item location="after">
                        <div className="d-flex align-items-center">
                            <label className="me-3">
                                <input
                                    type="checkbox"
                                    checked={todosFilter}
                                    onChange={handleTodosClick}
                                    className="me-1"
                                />
                                Todos
                            </label>

                            <label className="me-3">
                                <input
                                    type="checkbox"
                                    checked={recorrenteFilter}
                                    onChange={() => handleFilterChange(setRecorrenteFilter)}
                                    className="me-1"
                                />
                                Recorrentes
                            </label>

                            <label className="me-3">
                                <input
                                    type="checkbox"
                                    checked={abertoFilter}
                                    onChange={() => handleFilterChange(setAbertoFilter)}
                                    className="me-1"
                                />
                                Abertos
                            </label>

                            <label className="me-3">
                                <input
                                    type="checkbox"
                                    checked={agruparPorTipo}
                                    onChange={() => setAgruparPorTipo(!agruparPorTipo)}
                                    className="me-1"
                                />
                                Agrupar por Tipo
                            </label>
                        </div>
                    </Item>

                    <Item name="searchPanel" />
                </Toolbar>

                <Paging defaultPageSize={20} />
                <Scrolling mode="infinite" />
                <LoadPanel enabled />

                <GroupPanel visible={agruparPorTipo} />
                <SearchPanel visible highlightCaseSensitive />
                <Grouping autoExpandAll={agruparPorTipo} />
                <Sorting mode="single" />

                {/* Agrupamento por Tipo de Documento (dinâmico) */}
                <Column
                    dataField="cad_fin_documento_tipo_id"
                    caption="TIPO"
                    width={200}
                    groupIndex={agruparPorTipo ? 0 : undefined} // Se "Agrupar por Tipo" estiver marcado, agrupa
                    visibleIndex={agruparPorTipo ? undefined : 4} // Se não estiver agrupado, move para depois de "ENTIDADE"
                >
                    <Lookup dataSource={tipoData} valueExpr="id" displayExpr="nome" />
                </Column>

                <Column caption="id" dataField="id" alignment="center" dataType="number" width={70} allowEditing={false} cellRender={cellRenderId} sortOrder="desc" />
                <Column caption="EMISSÃO" dataField="emissao" alignment="center" dataType="date" width={100} />

                <Column dataField="cad_entidade_id" caption="ENTIDADE" width={600}>
                    <Lookup dataSource={entidadeData} valueExpr="id" displayExpr="nome" />
                </Column>

                {/* Ordenação automática pela coluna "Observação" */}
                <Column caption="OBSERVAÇÃO" dataField="observacao" dataType="string" minWidth="120" sortIndex={0} sortOrder="asc" />
            </DataGrid>
        </DefaultContainer>
    );
};
